import ApiClient from './ApiClient';

class LinkedinInboxApi extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getUsage(inboxId) {
    return window.axios.get(`${this.url}/${inboxId}/linkedin/usage`);
  }

  startChat(inboxId, { profileUrl, content, idempotencyKey }) {
    return window.axios.post(`${this.url}/${inboxId}/linkedin/chats`, {
      profile_url: profileUrl,
      content,
      idempotency_key: idempotencyKey,
    });
  }

  resume(inboxId) {
    return window.axios.post(`${this.url}/${inboxId}/linkedin/resume`);
  }
}

export default new LinkedinInboxApi();
